import { Component, OnInit } from "@angular/core";
//import { BrowserModule } from "@angular/platform-browser";
import { LoginService } from "../user/login.service";
import { Router } from "@angular/router";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable, pipe } from "rxjs";
import { map, takeUntil, tap } from "rxjs/operators";
import { UserResponse } from "../../shared/user-response";
import { UserModel } from "../../shared/user-model";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  constructor(private router: Router) { }
  ngOnInit() {
    let u = JSON.parse(localStorage.getItem('currentUser'));
    if (u != null) {
      this.router.navigateByUrl('/user-portal/user-menu');
    }
    else {
      this.router.navigateByUrl('/login');
    }
  }
}
